<template>
  <funding-base :state="state">
    <funding-projects-filter
      :route-name="state.route"
      :competitions="state.competitions"
      :funding-pot="state.funding_pot"
      @filter:selected="initialCompetition = $event"
    />
    <template v-if="state.projects.length">
      <div class="container -mt-6">
        <div class="flex flex-wrap items-baseline mb-6">
          <div class="w-full md:w-3/4 flex items-baseline">
            <h2 class="text-2xl mb-2 pr-6 mr-6 border-r">
              {{ title }}
            </h2>
            <p class="pb-1">
              {{ filteredProjects.length }} Projects
            </p>
          </div>
          <div
            class="hidden md:flex w-1/4 border items-center focus-within:bg-white focus-within:border-primary-300 transition-all transition-normal"
          >
            <input
              v-model="search"
              placeholder="Search Projects"
              type="search"
              class="flex-1 px-4 py-2 bg-transparent outline-none"
            />
            <icon
              icon="search"
              class="icons-primary w-6 h-6 mr-2"
            />
          </div>
          <div class="my-4">
            <icon-link
              v-for="exportCompetition in competitions"
              :key="exportCompetition.uuid"
              icon="cloud-download"
              class="mr-2"
              target="_blank"
              :href="route('funding.claims.export', {
                funding: exportCompetition.funding_pots[0].id,
                competition: exportCompetition.uuid,
              })"
            >
              Export {{ exportCompetition.title }} Claims
            </icon-link>
          </div>
        </div>
        <template v-if="filteredProjects.length">
          <ul class="list-reset flex flex-wrap">
            <li
              v-for="project in filteredProjects"
              :key="project.uuid"
              class="w-full mb-24"
            >
              <funding-project-claims
                :project="project"
                :funding-pot="state.funding_pot.id"
                :claim-periods="state.claim_periods"
                :project-claim-requests="projectClaims(project.id)"
                :project-balances="projectBalances(project.id)"
                :collaboration-agreement="
                  requiresCollaborationAgreement(project.competition_id)
                "
              />
            </li>
          </ul>
        </template>
        <template v-else>
          <div class="w-full flex h-48 items-center justify-center">
            <div class="text-center">
              <h2 class="text-2xl">
                No Results
              </h2>
              <p>
                We can't find any projects for
                <em class="text-primary-500">"{{ search }}"</em>
              </p>
            </div>
          </div>
        </template>
      </div>
    </template>
  </funding-base>
</template>

<script>
import Fuse from "fuse.js";
export default {
  name: "FundingClaimsIndex",
  data() {
    return {
      initialCompetition: null,
      search: ""
    };
  },
  computed: {
    title() {
      return this.initialCompetition
        ? this.filteredCompetitions[0].title + " Projects"
        : this.search
        ? 'Search results for: "' + this.search + '"'
        : "All Projects";
    },
    competitions() {
      return !this.initialCompetition
        ? this.state.competitions
        : this.filteredCompetitions;
    },
    filteredCompetitions() {
      return this.state.competitions.filter(
        competition => competition.uuid === this.initialCompetition
      );
    },
    projects() {
      if (!this.initialCompetition)
        return [...this.state.projects].sort(this.projectOrder);
      return this.state.projects
        .filter(
          project => this.filteredCompetitions[0].id === project.competition_id
        )
        .sort(this.projectOrder);
    },
    filteredProjects() {
      if (!this.search) return this.projects;
      const options = {
        shouldSort: true,
        tokenize: true,
        threshold: 0.2,
        location: 0,
        distance: 100,
        maxPatternLength: 32,
        minMatchCharLength: 3,
        keys: ["ref", "title", "partner_entries.name"]
      };
      const results = new Fuse(this.projects, options);
      return results.search(this.search);
    }
  },
  methods: {
    projectClaims(project_id) {
      return this.state.claim_requests.filter(
        request => project_id === request.competition_project_id
      );
    },
    projectBalances(project_id) {
      return this.state.partner_balances.filter(
        request => project_id === request.competition_project_id
      );
    },
    projectOrder(a, b) {
      if (!a.terminated_at && !b.terminated_at) {
        return -1;
      } else {
        return 1;
      }
    },
    requiresCollaborationAgreement(competition_id) {
      const projectCompetition = this.competitions.find(
        competition => competition.id === competition_id
      );
      if (!projectCompetition) return false;
      return projectCompetition.requires_collaboration_agreement_upload
        ? true
        : false;
    }
  }
};
</script>
